import { render, staticRenderFns } from "./ProviderDetails.vue?vue&type=template&id=7b0d6849"
import script from "./ProviderDetails.vue?vue&type=script&lang=js"
export * from "./ProviderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports